import React from 'react';
import { useTranslation } from 'react-i18next';
import { Store } from '../../../../store';
import { changeSearchOptions } from '../../../../store/ducks/pesquisa';
import { Row, Col, Input } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classnames from 'classnames';
import { useAccessibilityContext } from '../../../consulta-acessibilidade/contexts/AccessibilityContext';
import Button from '../../../consulta-acessibilidade/Button';

const PesquisaAutoridades = props => {
    const { t } = useTranslation();
    const { searchInputRef } = useAccessibilityContext();

    //? Valores dentro do select:
    const termos = [
        { label: t('AUTORIDADE_TODOS'), value: 'AUTORIDADE_TODOS' },
        { label: '-------', value: 'sep' },
        {
            label: t('AUTORIDADE_AUTORES_PESSOAS'),
            value: 'AUTORIDADE_AUTORES_PESSOAS',
        },
        {
            label: t('AUTORIDADE_AUTORES_INSTITUICOES'),
            value: 'AUTORIDADE_AUTORES_INSTITUICOES',
        },
        {
            label: t('AUTORIDADE_AUTORES_EVENTOS'),
            value: 'AUTORIDADE_AUTORES_EVENTOS',
        },
        {
            label: t('AUTORIDADE_TITULO_UNIFORME'),
            value: 'AUTORIDADE_TITULO_UNIFORME',
        },
        { label: '-------', value: 'sep' },
        { label: t('AUTORIDADE_ASSUNTOS'), value: 'AUTORIDADE_ASSUNTOS' },
        {
            label: t('AUTORIDADE_ASSUNTOS_GEOGRAFICOS'),
            value: 'AUTORIDADE_ASSUNTOS_GEOGRAFICOS',
        },
        {
            label: t('AUTORIDADE_GENERO_FORMA'),
            value: 'AUTORIDADE_GENERO_FORMA',
        },
        {
            label: t('AUTORIDADE_TERMO_CRONOLOGICO'),
            value: 'AUTORIDADE_TERMO_CRONOLOGICO',
        },
        { label: '-------', value: 'sep' },
        {
            label: t('AUTORIDADE_SUBDIVISAO_GERAL'),
            value: 'AUTORIDADE_SUBDIVISAO_GERAL',
        },
        {
            label: t('AUTORIDADE_SUBDIVISAO_GENERO_FORMA'),
            value: 'AUTORIDADE_SUBDIVISAO_GENERO_FORMA',
        },
        {
            label: t('AUTORIDADE_SUBDIVISAO_GEOGRAFICA'),
            value: 'AUTORIDADE_SUBDIVISAO_GEOGRAFICA',
        },
        {
            label: t('AUTORIDADE_SUBDIVISAO_CRONOLOGICA'),
            value: 'AUTORIDADE_SUBDIVISAO_CRONOLOGICA',
        },
    ];

    const handleTextChange = e => {
        e.preventDefault();
        let valor = e.target.value;
        let optPesquisa = props.opcoesConsulta;
        optPesquisa[0].termo = valor;
        return Store.dispatch(changeSearchOptions(optPesquisa));
    };

    const handleComboChange = e => {
        e.preventDefault();
        let valor = e.target.value;
        let optPesquisa = props.opcoesConsulta;
        optPesquisa[0].option = valor;
        return Store.dispatch(changeSearchOptions(optPesquisa));
    };

    return (
        <Row className="content__left__input px-3">
            <Col lg="8" md="7" sm="12" className="input-holder mt-3">
                <div className='rotulo'>
                    {t('CampoBusca')}
                </div>
                <Input
                    innerRef={searchInputRef}
                    type="search"
                    className="rad10 b-tema20 cortxt foco"
                    name="q"
                    value={
                        props.opcoesConsulta.length
                            ? props.opcoesConsulta[0].termo
                            : ''
                    }
                    onChange={e => handleTextChange(e)}
                    placeholder={t('DigiteSuaBuscaAqui')}
                    invalid={props.error}
                />
                <div className="invalid-feedback">
                    {t('CampoBuscaObrigatorio')}
                </div>
            </Col>
            <Col lg="2" md="3" sm="12" className="input-holder mt-3">
                <div className='rotulo'>
                    {t('TipoPesquisas')}
                </div>
                <Input
                    type="select"
                    className="b-tema20 cortxt rad10 s14"
                    name="for"
                    value={
                        props.opcoesConsulta.length
                            ? props.opcoesConsulta[0].option
                            : ''
                    }
                    onChange={e => handleComboChange(e)}
                >
                    {termos.map((termo, index) =>
                        termo.value === 'sep' ? (
                            <option
                                disabled
                                key={`termo-${termo.value}${index}`}
                            >
                                {termo.label}
                            </option>
                        ) : (
                            <option
                                key={`termo-${termo.value}`}
                                value={termo.value}
                            >
                                {termo.label}
                            </option>
                        ),
                    )}
                </Input>
            </Col>
            <Col
                md="2"
                lg="2"
                sm="12"
                className={classnames(' mt-3 align-self-end', { 'mb-4': props.error })}
            >
                <Button
                    title="Pesquisar"
                    icon="search"
                    variant='primeiro ml-0 btn-responsivo'
                    type="submit"
                    disabled={props.loading}
                />
            </Col>
        </Row>
    );
};

export default PesquisaAutoridades;
